import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';




const firebaseConfig = {
    apiKey: "AIzaSyCVvJyV-kFGpeSvnG_QDqPjU8xNHe0vcVU",
    authDomain: "tik-tok-clone-c14c7.firebaseapp.com",
    projectId: "tik-tok-clone-c14c7",
    storageBucket: "tik-tok-clone-c14c7.appspot.com",
    messagingSenderId: "302501513179",
    appId: "1:302501513179:web:74a995b7e01cec971649fe"
};


const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();


export default db;